import { createAction } from 'redux-actions';

export const SHOW_MODAL = 'SHOW_MODAL';

export default createAction(SHOW_MODAL);
